import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NewPrompterReportService, NewPrompterReport, NewPrompterReportEmployee } from '../../services/new-prompter-report.service';

@Component({
  selector: 'app-display-new-prompter-report',
  templateUrl: './display-new-prompter-report.component.html',
  styleUrls: ['./display-new-prompter-report.component.css']
})
export class DisplayNewPrompterReportComponent implements OnInit, OnDestroy {

  id: string;
  reportEmployees: NewPrompterReportEmployee[]  = [];

  subs: Subscription[] = [];

  form: FormGroup;

  constructor(
    private service: NewPrompterReportService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');

    this.subs[0] = this.service.getNewPrompterReport(this.id).subscribe(report => {
      this.form.patchValue(report);
      this.reportEmployees = report.employees;
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      employeeName: '',
      odpName: '',
      date: '',
      time: '',
    });
  }
  ngOnDestroy(){
    for(let sub of this.subs) sub.unsubscribe();
  }

  onCancel(){
    this.service.windowReplace.read();
  }

}
